export default {
  name: 'PassPort',
  props: {
    passport_data: {
      type: Object,
      default: () => ({
        customerPassportDateOfIssue: '',
        passportValidToDate: '',
        customerResidencePermitType: 'Not Selected',
        customerResidencePermitNumber: '',
        customerResidencePermitCountryOfIssue: '',
        customerResidencePermitDateOfIssue: '',
        customerResidencePermitExpiryDate: '',
        customerWorkContractExpiryDate: ''
      })
    },
    countries: {
      type: Array,
      required: true
    }
  },
  watch: {
    passport_data: {
      handler(new_value) {
        this.$emit('update:passport_data', new_value);
      },
      deep: true
    }
  },
};